module.exports = __webpack_public_path__ + "img/patrulla_gnacional_down.36ab09b8.svg";